/* eslint-disable no-undef */
const brownianFloat = (element) => gsap.to(element, {
  x: 'random(-20, 20, 5)',
  y: 'random(-20, 10, 3)',
  ease: 'sine.inOut',
  duration: gsap.utils.random([2, 4]),
  onComplete: () => brownianFloat(element),
})

export default brownianFloat
